<template>
  <div class="product-bg-wrapper">
    <div class="product-bg">
      <img :src="bg" alt="product" />
    </div>
    <div class="product-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.product-bg-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  .product-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    img {
      max-width: 100%;
    }
  }
  .product-content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;

    .video-intro {
      position: absolute;
      width: 720px;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      h2 {
        text-align: center;
        font-size: 28px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        font-weight: 300;
        color: #ffffff;
        line-height: 26px;
        margin-bottom: 30px;
        text-align: center;
      }
      .btn-wrapper {
        width: 100%;
        text-decoration: none;
        .btn-content {
          box-sizing: border-box;
          width: 162px;
          height: 40px;
          padding: 12px 25px;
          background: #226bfb;
          border-radius: 20px;
          margin: 0 auto;
          cursor: pointer;
          img {
            max-width: 20px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }

    .operate-intro {
      position: absolute;
      // width: 720px;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      h2 {
        text-align: center;
        font-size: 28px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        font-weight: 300;
        color: #ffffff;
        line-height: 26px;
        margin-bottom: 30px;
      }
      .btn-wrapper {
        width: 100%;
        text-align: center;
        .btn-content {
          box-sizing: border-box;
          width: 162px;
          height: 40px;
          padding: 12px 25px;
          background: #226bfb;
          border-radius: 20px;
          margin: 0 auto;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
    .apply-intro {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      h2 {
        text-align: center;
        font-size: 44px;
        font-weight: bold;
        color: #ffffff;
        line-height: 56px;
      }
    }
  }
}
@media (max-width: 1600px) {
  .product-bg-wrapper {
    height: 480px;
  }
  .product-content {
    height: 480px;
  }
  .video-intro {
    top: 80px;
  }
  .operate-intro {
    top: 150px;
  }
  .apply-intro {
    top: 160px;
  }
}
@media (min-width: 1601px) {
  .product-bg-wrapper {
    height: 640px;
  }
  .product-content {
    height: 640px;
  }
  .video-intro {
    top: 150px;
  }
  .operate-intro {
    top: 240px;
  }
  .apply-intro {
    top: 240px;
  }
}
</style>